import { createReducer, on } from '@ngrx/store';
import { changeEndYearMonth, changeStartYearMonth } from './span.action';
import { getReferenceDataSuccess } from './accounting.action';
import { BusinessYear } from '../model/accounting.model';

export default interface SpanState {
  businessYears: BusinessYear[];
  startYear: number;
  startMonth: number;
  endMonth: number;
  endYear?: number;
}

export const initialState: SpanState = {
  businessYears: [],
  startYear: new Date().getFullYear(),
  startMonth: 0,
  endMonth: 11,
  endYear: undefined,
};

export const reducer = createReducer(
  initialState,
  on(getReferenceDataSuccess, (state, { companyData }): SpanState => {
    const currentDateTime = new Date().getTime();

    const orderedBusinessYears = companyData.businessYears.slice().sort((a, b) => a.start.localeCompare(b.start));
    const currentBusinessYear = orderedBusinessYears.find(businessYears =>
      currentDateTime >= new Date(businessYears.start).getTime() && currentDateTime <= new Date(businessYears.end).getTime()
    ) ?? companyData.businessYears.slice(-1)[0]
    const startDate = new Date(currentBusinessYear.start);
    const endDate = new Date(currentBusinessYear.end);
    return {
      ...state,
      businessYears: orderedBusinessYears,
      startMonth: startDate.getMonth(),
      startYear: startDate.getFullYear(),
      endMonth: endDate.getMonth(),
      endYear: endDate.getFullYear()
    }
  }),
  on(changeStartYearMonth, (state, { year, month }): SpanState => {
    const startDate = new Date(year, month);
    let endDate = new Date(state.endYear ?? state.startYear, state.endMonth);
    if (startDate.getTime() >= endDate.getTime()) {
      endDate = new Date(startDate.getTime());
      endDate.setMonth(endDate.getMonth() + 11);
    }
    return {
      ...state,
      startMonth: month,
      startYear: year,
      endMonth: endDate.getMonth(),
      endYear: endDate.getFullYear()
    }
  }),
  on(changeEndYearMonth, (state, { year, month }): SpanState => {
    let startDate = new Date(state.startYear, state.startMonth);
    const endDate = new Date(year, month);
    if (startDate.getTime() >= endDate.getTime()) {
      startDate = new Date(endDate.getTime());
      startDate.setMonth(startDate.getMonth() - 11);
    }
    return {
      ...state,
      startMonth: startDate.getMonth(),
      startYear: startDate.getFullYear(),
      endMonth: month,
      endYear: year
    }
  }),
);
